import { Settings } from "@templates"

import NotificationTopicsCards from "./NotificationTopicsCards/NotificationTopicsCards"
import NotificationMethodsSection from "./components/NotificationMethodsSection/NotificationMethodsSection"

export default function SettingsNotifications() {
    return (
        <Settings.Wrapper title="Notifications">
            <Settings.PageContainer>
                <Settings.PageHeader
                    variant="page-heading"
                    title="Notifications"
                    subtitle="Select how and when you'll be notified."
                />

                <Settings.Divider />

                <Settings.Section>
                    <Settings.PageHeader
                        variant="section-heading"
                        title="Notification methods"
                        subtitle="Choose the methods via which you want to stay up to date with new activity."
                    />
                    <NotificationMethodsSection />
                </Settings.Section>

                <Settings.Divider />

                <Settings.Section>
                    <Settings.PageHeader
                        variant="section-heading"
                        title="Notification topics"
                        subtitle="Select which notification topics you want to receive via each method."
                    />
                    <NotificationTopicsCards />
                </Settings.Section>
            </Settings.PageContainer>
        </Settings.Wrapper>
    )
}
